module.exports = __webpack_public_path__ + "static/media/README.b5b0df97.md";


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/README.md
// module id = 368
// module chunks = 0